import { call, put, takeEvery } from 'redux-saga/effects';
import { apiPython as api } from '../../../service/api';
import URLs from '../../../constants/urls';
import { unwrapApiPayload, normalizeAssessmentLists } from '../../../utils/apiPayload';
import {
  fetchSelfAssessmentFailure,
  fetchSelfAssessmentRequest,
  fetchSelfAssessmentSuccess
} from '../../features/SelfAssessmentScreen/SelfAssessmentScreenSlice';

function normalizeSelfIndexPayload(envelope) {
  const inner = unwrapApiPayload(envelope) || {};
  const normalized = normalizeAssessmentLists(inner);
  return {
    ...envelope,
    data: {
      ...normalized,
      cycleId: normalized.cycleId ?? normalized.CycleId,
      cycleResponseId: normalized.cycleResponseId ?? normalized.CycleResponseId,
      cycleName: normalized.cycleName ?? normalized.CycleName,
      cycleType_Id:
        normalized.cycleType_Id ??
        normalized.cycleTypeId ??
        normalized.CycleType_Id,
      isUserWindow: normalized.isUserWindow ?? normalized.IsUserWindow,
    },
  };
}

function* fetchSelfAssessmentSaga(action) {
  const { id, isAssessor, SAMId, SkillId, LoginSamID } = action.payload;
  const enc = (v) => encodeURIComponent(v === undefined || v === null ? '' : String(v));
  try {
    const response = yield api.get(
      `${URLs.GET_SELF_ASSESSMENT_SCREEN}?id=${enc(id)}&isAssessor=${enc(isAssessor)}&SAMId=${enc(SAMId)}&SkillId=${enc(SkillId)}&LoginSamID=${enc(LoginSamID)}`
    );
    yield put(fetchSelfAssessmentSuccess(normalizeSelfIndexPayload(response.data)));
  } catch (error) {
    yield put(fetchSelfAssessmentFailure(error.message));
  }
}

function* watchFetchSelfAssessment() {
  yield takeEvery(fetchSelfAssessmentRequest.type, fetchSelfAssessmentSaga);
}

export default watchFetchSelfAssessment;
